import { defineStyle as o, defineStyleConfig as a } from "@chakra-ui/react";
const r = o({
  boxSize: 4,
  color: "secondary.500",
  "&[data-animated='true']": {
    animation: "svg-shadow 500ms ease-in-out infinite alternate",
    "@keyframes svg-shadow": {
      "0%": {
        filter: "drop-shadow(0 0 0 #fff) drop-shadow(0 0 0 var(--chakra-colors-secondary-500))"
      },
      "40% - 55%": {
        filter: "drop-shadow(0 0 1px #fff) drop-shadow(0 0 1px var(--chakra-colors-secondary-500))"
      },
      "100%": {
        filter: "drop-shadow(0 0 2px #fff) drop-shadow(0 0 2px var(--chakra-colors-secondary-500))"
      }
    }
  }
}), d = a({ baseStyle: r });
export {
  d as MagicAnimatedIcon
};
//# sourceMappingURL=MagicAnimatedIcon.es.js.map
